import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { GroupSettings } from '../objects/group-settings';
import { LocalStorageService } from './local-storage.service';
import { Group } from '../objects/group';
import { LedgerEntry } from 'src/app/objects/ledger-entry';


const API_URL = environment.BASE_API_URL + 'GGKGroupWebService.asmx/';
const GGK_API_KEY = environment.GGK_API_KEY;

@Injectable()
export class GroupService {

  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService
  ) { }

  post<T>(url: string, payload: any) {
    return this.http.post<T>(url, payload, { params: { 'api_key': GGK_API_KEY } });
  }

  get<T>(url: string) {
    return this.http.post<T>(url, { params: { 'api_key': GGK_API_KEY } });
  }

  setAdminGroups(groups: Group[]) {
    this.localStorage.set('adminGroups', groups);
  }

  getAdminGroups(): Group[] {
    return this.localStorage.get('adminGroups');
  }

  getGroupAdmins(group_id: string) {
    let payload = { group_id: group_id };
    let url = API_URL + 'getGroupAdmins';

    return this.post<any>(url, payload);
  }

  addPlayerToGroup(group_id: string, first: string, last: string, email: string, handicap: string): Observable<any> {
    let payload = { group_id: group_id, first: first, last: last, email: email, handicap: handicap };
    let url = API_URL + 'addPlayerToGroup';

    return this.post<any>(url, payload);
  }

  addPlayerToGroupWithGhin(group_id: string, first: string, last: string, email: string, handicap: string, ghin_id: string): Observable<any> {
    let payload = { group_id: group_id, first: first, last: last, email: email, handicap: handicap, ghin_id: ghin_id };
    let url = API_URL + 'addPlayerToGroupWithGhin';

    return this.post<any>(url, payload);
  }

  upgradeMembership(groupId: string, newMembershipId: string, stripeSubscriptionId: string) {
    let payload = { groupId: groupId, newMembershipId: newMembershipId, stripeSubscriptionId: stripeSubscriptionId };
    let url = API_URL + 'upgradeMembership';

    return this.post<any>(url, payload);
  }

  checkPromoCode(code: string) {
    let payload = { promoCode: code };
    let url = API_URL + 'checkPromoCode';

    return this.post<any>(url, payload);
  }

  cancelMembership(groupId: string, playerId: string, stripeSubscriptionId: string) {
    let payload = { groupId: groupId, playerId: playerId, stripeSubscriptionId: stripeSubscriptionId };
    let url = API_URL + 'cancelMembership';

    return this.post<any>(url, payload);
  }

  reactivateMembership(groupId: string, playerId: string, stripeSubscriptionId: string) {
    let payload = { groupId: groupId, playerId: playerId, stripeSubscriptionId: stripeSubscriptionId };
    let url = API_URL + 'reactivateMembership';

    return this.post<any>(url, payload);
  }

  createLeagueOrTrip(playerId: string, name: string, type: string, seasonStart: string, seasonEnd: string) {
    let payload = { playerId: playerId, name: name, type: type, seasonStart: seasonStart, seasonEnd: seasonEnd };
    let url = API_URL + 'createLeagueOrTrip';

    return this.post<any>(url, payload);
  }

  getGroupSeason(groupId: string) {
    let payload = { groupId: groupId };
    let url = API_URL + 'getGroupSeason';

    return this.post<any>(url, payload);
  }

  getActiveSeason(group_id: string) {
    let payload = { group_id: group_id };
    let url = API_URL + 'getActiveSeason';

    return this.post<any>(url, payload);
  }

  getSeasonInfo(group_id: string, season_id) {
    let payload = { group_id: group_id, season_id: season_id };
    let url = API_URL + 'getSeasonInfo';

    return this.post<any>(url, payload);
  }

  getSubscriptionInfo(player_id: string, subscription_id: string) {
    let payload = { player_id: player_id, subscription_id: subscription_id };
    let url = API_URL + 'GetSubscriptionInfo';

    return this.post<any>(url, payload);
  }

  GetStripeCustomer(customer_id: string) {
    let payload = { customer_id: customer_id };
    let url = API_URL + 'GetStripeCustomer';

    return this.post<any>(url, payload);
  }


  UpdateSubscriptionPaymentMethod(subscription_id: string, player_id: string, token: string) {
    let payload = { subscription_id: subscription_id, player_id: player_id, token: token };
    let url = API_URL + 'UpdateSubscriptionPaymentMethod';

    return this.post<any>(url, payload);
  }

  UpdatePaymentMethod(customer_id: string, token: string) {
    let payload = { customer_id: customer_id, token: token };
    let url = API_URL + 'UpdatePaymentMethod';

    return this.post<any>(url, payload);
  }

  getPaymentMethod(customer_id: string) {
    let payload = { customer_id: customer_id };
    let url = API_URL + 'getPaymentMethod';

    return this.post<any>(url, payload);
  }

  createGroup(playerId: string, name: string, type: string) {
    let payload = { playerId: playerId, groupName: name, groupType: type };
    let url = API_URL + 'createGroup';

    return this.post<any>(url, payload);
  }

  deleteGroup(groupId: string) {
    let payload = { groupId: groupId };
    let url = API_URL + 'deleteGroup';

    return this.post<any>(url, payload);
  }

  removePlayerFromGroup(group_id: string, player_id: string) {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'removePlayerFromGroup';

    return this.post<any>(url, payload);
  }

  addPlayerToGroupFromPlayerId(group_id: string, player_id: string) {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'addPlayerToGroupFromPlayerId';

    return this.post<any>(url, payload);
  }

  getGroupSettings(group_id: string): Observable<any> {
    let payload = { group_id: group_id };
    let url = API_URL + 'getGroupSettings';

    return this.post<any>(url, payload);
  }

  getLeagueSponsors(group_id: string): Observable<any> {
    let payload = { group_id: group_id };
    let url = API_URL + 'getLeagueSponsors';

    return this.post<any>(url, payload);
  }

  getGroupPlayers(group_id: string): Observable<any> {
    let payload = { group_id: group_id };
    let url = API_URL + 'getGroupPlayers';

    return this.post<any>(url, payload);
  }

  getGroupPlayerStats(group_id: string, rounds_definition: string = '18_holes'): Observable<any> {
    let payload = { group_id: group_id, rounds_definition: rounds_definition };
    let url = API_URL + 'getGroupPlayerStats';

    return this.post<any>(url, payload);
  }

  getGroupPlayerRoundsPlayed(group_id: string): Observable<any> {
    let payload = { group_id: group_id };
    let url = API_URL + 'getGroupPlayerRoundsPlayed';

    return this.post<any>(url, payload);
  }

  setGroupPlayerAsAdmin(group_id: string, player_id: string): Observable<any> {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'setGroupPlayerAsAdmin';

    return this.post<any>(url, payload);
  }

  setPlayerActiveSeason(group_id: string, player_id: string, active_season: string): Observable<any> {
    let payload = { group_id: group_id, player_id: player_id, active_season: active_season };
    let url = API_URL + 'setPlayerActiveSeason';

    return this.post<any>(url, payload);
  }

  removeGroupAdmin(group_id: string, player_id: string): Observable<any> {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'removeGroupAdmin';

    return this.post<any>(url, payload);
  }

  setAsGroupOwner(group_id: string, player_id: string): Observable<any> {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'setAsGroupOwner';

    return this.post<any>(url, payload);
  }

  saveGroupSettings(payload: GroupSettings): Observable<any> {
    let url = API_URL + 'saveGroupSettings';

    return this.post<any>(url, payload);
  }

  saveMembershipFees(season_id: string, fees_in_cent: number): Observable<any> {
    let payload = { season_id: season_id, fees_in_cent: fees_in_cent }
    let url = API_URL + 'saveMembershipFees';

    return this.post<any>(url, payload);
  }

  saveMaxHcp(group_id: number, max_strokes: number) {
    let payload = { group_id: group_id, max_strokes: max_strokes };
    let url = API_URL + 'saveMaxHcp';

    return this.post<any>(url, payload);
  }

  getGroupEventYears(group_id: string) {
    let payload = { group_id: group_id };
    let url = API_URL + 'getGroupEventYears';

    return this.post<any>(url, payload);
  }

  saveCustomHandicapSchemes(group_id: string, scheme_data: string) {
    let payload = { group_id: group_id, scheme_data: scheme_data };
    let url = API_URL + 'saveCustomHandicapSchemes';

    return this.post<any>(url, payload);
  }

  getHandicapSchemes(group_id: string) {
    let payload = { group_id: group_id };
    let url = API_URL + 'getAvailableHandicapSchemes';

    return this.post<any>(url, payload);
  }

  fetchGroupAvgRounds(group_id: string, player_id: string) {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'fetchGroupAvgRounds';

    return this.post<any>(url, payload);
  }

  getGroupRounds(group_id: string, player_id: string) {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'getGroupRounds';

    return this.post<any>(url, payload);
  }

  saveGroupPlayerEmail(group_id: string, player_id: string, email: string) {
    let payload = { group_id: group_id, player_id: player_id, email: email };
    let url = API_URL + 'saveGroupPlayerEmail';

    return this.post<any>(url, payload);
  }

  savePlayerGhin(group_id: string, player_id: string, ghin: string) {
    let payload = { group_id: group_id, player_id: player_id, ghin: ghin };
    let url = API_URL + 'savePlayerGhin';

    return this.post<any>(url, payload);
  }

  updateGroupIndexFromGhin(group_id: string, player_id: string, ghin: string) {
    let payload = { group_id: group_id, player_id: player_id, ghin: ghin };
    let url = API_URL + 'updateGroupIndexFromGhin';

    return this.post<any>(url, payload);
  }


  sendWelcomeToGroupEmail(group_id: string, player_id: string) {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'sendWelcomeToGroup';

    return this.post<any>(url, payload);

  }

  getGroupPlayerProfile(group_id: string, player_id: string) {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'getGroupPlayerProfile';

    return this.post<any>(url, payload);
  }

  // WI 77: Tee Exception rules available to a group (active global + group-scoped), for the dropdown.
  getTeeExceptionRules(group_id: string) {
    let payload = { group_id: group_id };
    let url = API_URL + 'getTeeExceptionRules';

    return this.post<any>(url, payload);
  }

  addGroupPlayer(payload: any) {
    let url = API_URL + 'ggkAddGroupPlayer';

    return this.post<any>(url, payload);
  }

  updateGroupPlayer(payload: any) {
    let url = API_URL + 'updateGroupPlayer';

    return this.post<any>(url, payload);
  }

  getGroupTournamentRounds(group_id: string, player_id: string) {
    let body = { group_id: group_id, player_id: player_id };
    let _url = API_URL + 'getGroupTournamentRounds';

    return this.post<any>(_url, body);
  }

  requestClientAuthentication(code: string, player_id: string, group_id: string) {
    let body = { code: code, group_id: group_id, player_id: player_id };
    let _url = API_URL + 'requestClientAuthentication';

    return this.post<any>(_url, body);
  }

  createChargeForCustomer(token: string, amount: number, note: string, group_id: string, player_id: string) {
    let body = { token: token, amount: amount, note: note, group_id: group_id, player_id: player_id };
    let _url = API_URL + 'CreateChargeForCustomer';

    return this.post<any>(_url, body);
  }

  recalculateGroupIndex(group_id: string) {
    let payload = { group_id: group_id };
    let url = API_URL + 'recalculateGroupIndex';

    return this.post<any>(url, payload);
  }

  clearGroupStandingsCache(group_id: string, season: string) {
    let payload = { groupId: group_id, season: season };
    let url = API_URL + 'clearGroupStandingsCache';

    return this.post<any>(url, payload);
  }

  getNetGroupStandings(group_id: string, season: string) {
    let payload = { groupId: group_id, season: season };
    let url = API_URL + 'getNetGroupStandings';

    return this.post<any>(url, payload);
  }

  forceRecalculateQuotaLeagueStandings(group_id: string, season: string) {
    let payload = { groupId: group_id, season: season };
    let url = API_URL + 'forceRecalculateQuotaLeagueStandings';

    return this.post<any>(url, payload);
  }

  getQuotaLeagueStandings(group_id: string, season: string) {
    let payload = { groupId: group_id, season: season };
    let url = API_URL + 'getQuotaLeagueStandings';

    return this.post<any>(url, payload);
  }

  getGrossGroupStandings(group_id: string, season: string) {
    let payload = { groupId: group_id, season: season };
    let url = API_URL + 'getGrossGroupStandings';

    return this.post<any>(url, payload);
  }

  checkIfExpired(group_id: string) {
    let payload = { group_id: group_id };
    let url = API_URL + 'checkIfExpired';

    return this.post<any>(url, payload);
  }

  addChallengeHole(group_id: string, group_event_id: string, season: string, hole: string) {
    let payload = { group_id: group_id, group_event_id: group_event_id, season: season, hole: hole };
    let url = API_URL + 'addChallengeHole';

    return this.post<any>(url, payload);
  }
  getChallengePageData(group_id: string, season: string, is_admin: string) {
    let payload = { group_id: group_id, season: season, is_admin: is_admin };
    let url = API_URL + 'getChallengePageData';

    return this.post<any>(url, payload);
  }

  calculateChallengeHole(group_id: string, season: string, uid: string) {
    let payload = { group_id: group_id, season: season, uid: uid };
    let url = API_URL + 'calculateChallengeHole';

    return this.post<any>(url, payload);
  }

  removeChallengeHole(challenge_id: string, group_id: string, season: string) {
    let payload = { challenge_id: challenge_id, group_id: group_id, season: season };
    let url = API_URL + 'removeChallengeHole';

    return this.post<any>(url, payload);
  }

  getSeasons(group_id: string) {
    let payload = { group_id: group_id };
    let url = API_URL + 'getSeasons';

    return this.post<any>(url, payload);
  }

  createNewSeason(group_id: string, name: string, startDate: string, endDate: string) {
    let payload = { group_id: group_id, name: name, startDate: startDate, endDate: endDate };
    let url = API_URL + 'createNewSeason';

    return this.post<any>(url, payload);
  }

  clearGroupScores(group_id: string, player_id: string, from_date: string) {
    let payload = { group_id: group_id, player_id: player_id, from_date: from_date };
    let url = API_URL + 'clearTeamScores';

    return this.post<any>(url, payload);
  }

  getQuotaRounds(groupId: string, season: string, player_id: string) {
    let payload = { groupId: groupId, player_id: player_id, season: season };
    let url = API_URL + 'getQuotaRounds';

    return this.post<any>(url, payload);
  }

  getGroupByUsgaClubId(usga_club_id: number) {
    let payload = { usga_club_id: usga_club_id };
    let url = API_URL + 'getGroupByUsgaClubId';

    return this.post<any>(url, payload);
  }

  getClubsForGeoLocation(latitude: string, longitude: string) {
    let payload = { latitude: latitude, longitude: longitude };
    let url = API_URL + 'getClubsForGeoLocation';

    return this.post<any>(url, payload);
  }

  getClubsForZip(zip) {
    let payload = { zip: zip };
    let url = API_URL + 'getClubsForZip';

    return this.post<any>(url, payload);
  }

  getClubsByIpAddress() {
    let url = API_URL + 'getClubsByIpAddress';

    return this.get<any>(url);
  }

  createMembershipInvite(group_id: number, player_id: number) {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'createMembershipInvite';

    return this.post<any>(url, payload);
  }

  getMembershipInvite(group_id: number, player_id: number) {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'getMembershipInvite';

    return this.post<any>(url, payload);
  }

  clearMembershipInvite(group_id: number, player_id: number) {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'clearMembershipInvite';

    return this.post<any>(url, payload);
  }


  getInvitedPlayerIds(group_id: number) {
    let payload = { group_id: group_id };
    let url = API_URL + 'getInvitedPlayerIds';

    return this.post<any>(url, payload);
  }

  getPlayerLedger(group_id: string, player_id: string) {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'getPlayerLedger';

    return this.post<any>(url, payload);
  }

  getGroupLedger(group_id: string) {
    let payload = { group_id: group_id };
    let url = API_URL + 'getGroupLedger';

    return this.post<any>(url, payload);
  }

  getGroupLedgerByDateRange(group_id: string, start_date: string, end_date: string) {
    let payload = { group_id: group_id, start_date: start_date, end_date: end_date };
    let url = API_URL + 'getGroupLedgerByDateRange';

    return this.post<any>(url, payload);
  }

  addLedgerEntry(payload: LedgerEntry) {
    let url = API_URL + 'addLedgerEntry';

    return this.post<any>(url, payload);
  }

  checkLedgerEntriesForEvent(group_id: string, source_event_id: string) {
    let url = API_URL + 'checkLedgerEntriesForEvent';
    return this.post<any>(url, { group_id, source_event_id });
  }

  deleteLedgerEntriesForEvent(group_id: string, source_event_id: string) {
    let url = API_URL + 'deleteLedgerEntriesForEvent';
    return this.post<any>(url, { group_id, source_event_id });
  }

  getActiveSeasonYear(group_id: string) {
    let url = API_URL + 'getActiveSeasonYear';
    return this.post<any>(url, { group_id });
  }

  assignLeaguePoints(payload: any) {
    let url = API_URL + 'assignLeaguePoints';
    return this.post<any>(url, payload);
  }

  checkLeaguePointsForEvent(group_id: string, group_event_id: string) {
    let url = API_URL + 'checkLeaguePointsForEvent';
    return this.post<any>(url, { group_id, group_event_id });
  }

  deleteLeaguePointsForEvent(group_id: string, group_event_id: string) {
    let url = API_URL + 'deleteLeaguePointsForEvent';
    return this.post<any>(url, { group_id, group_event_id });
  }

  getPlayerTotalCredits(group_id: string, player_id: string) {
    let payload = { group_id: group_id, player_id: player_id };
    let url = API_URL + 'getPlayerTotalCredits';

    return this.post<any>(url, payload);
  }

  processPlayerIndexAdjustment(group_id: string, player_id: string, adjustment: string) {
    let payload = { group_id: group_id, player_id: player_id, adjustment: adjustment };
    let url = API_URL + 'processPlayerIndexAdjustment';

    return this.post<any>(url, payload);
  }

  ggkActivateSeason(group_id: string, season_id: string) {
    let url = API_URL + 'ggkActivateSeason';
    return this.post<any>(url, { group_id, season_id });
  }

  ggkCreateNewSeason(seasonPayload: any, group_id: string, set_as_active: boolean) {
    let url = API_URL + 'ggkCreateNewSeason';
    return this.post<any>(url, { league_season: seasonPayload, group_id, set_as_active });
  }

  saveSeason(payload: any) {
    // Backend exposes ggkSaveSeason(LeagueSeasonRequest league_season); there is no plain
    // "saveSeason" web method. Call ggkSaveSeason with the payload wrapped as league_season,
    // mirroring ggkCreateNewSeason. (Previously posted to API/saveSeason, which does not exist,
    // so editing an existing season always failed with "Failed to save season".)
    let url = API_URL + 'ggkSaveSeason';
    return this.post<any>(url, { league_season: payload });
  }
}
